import React, { useLayoutEffect, useState, useEffect } from 'react';
import PageTitle from '../common/PageTitle';
import DeliveryInfo from './components/DeliveryInfo';
import AdminSettings from './components/AdminSettings';
import PaymentMethod from './components/PaymentMethod';
import Checkout from './components/Checkout';
import Warehouse from './components/Warehouse';
import Stock from './components/Stock';
import PageMenu from '../common/PageMenu';
import { scrollToBlock } from '../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import {
  fetchGetAdminDeliveryInfo,
  fetchGetAdminSettings,
  fetchUpdateAdminCheckout,
  fetchUpdateAdminDeliveryInfo,
  fetchUpdateAdminPaymentMethod,
  fetchUpdateAdminSettings,
  fetchUpdateAdminWarehouse,
  fetchUpdateMpDtoOrders,
  fetchUpdateStock,
} from '../../actions/admin';
import { toast } from 'react-toastify';
import UnsavedHeader from './utils/UnsavedHeader';
import { Wrapper, ContentWrapper } from './styled';
import * as Yup from 'yup';
import ServiceProviders from './components/ServiceProviders';
import MpDtoOrders from './components/MpDtoOrders';
import Leftovers from './components/Leftovers';
import Corrections from './components/Corrections';
import Marketplaces from './components/Marketplaces';
import SubtypesFbo from './components/SubtypesFbo';

const menuData = [
  { title: 'Сверка остатков', id: 'leftovers', component: Leftovers },
  { title: 'Корректировки стока', id: ' correction', component: Corrections },
  { title: 'Маркетплейсы', id: 'marketplaces', component: Marketplaces },
  { title: 'Публичные настройки', id: 'checkout', component: Checkout },
  { title: 'Приватные настройки', id: 'lite', component: AdminSettings },
  { title: 'Доставка', id: 'delivery', component: DeliveryInfo },
  { title: 'Склады', id: 'warehouse', component: Warehouse },
  { title: 'МП DTO заказы', id: 'mp-dto-orders', component: MpDtoOrders },
  /*  { title: 'Оплата', id: 'shop', component: PaymentMethod },*/
  { title: 'Фулфилмент провайдеры', id: 'providers', component: ServiceProviders },
  { title: 'ФБО подтипы', id: 'subtypes-fbo', component: SubtypesFbo },

  /*  { title: 'Остатки', id: 'stock', component: Stock },*/
];

const validationSchema = Yup.object().shape({
  domain: Yup.string().matches(/^[^.]+$/, {
    message:
      "Недопустимый символ '.' в имени поддомена. Для разделения слов рекомендуем использовать символы - '_' и '-'",
    excludeEmptyString: true,
  }),
});

const AdminPage = (props) => {
  const { setCustomHeader } = props;
  const [currentBlock, setCurrentBlock] = useState(menuData[0]);
  const [menuOffset, setMenuOffset] = useState(null);
  const [loading, setLoading] = useState(false);
  const [stockRevise, setStockRevise] = useState(null);
  const adminSettings = useSelector((state) => state.admin);
  const dispatch = useDispatch();

  //Отслеживание сохраненных настроек
  const [deliveryUnsaved, setDeliveryUnsaved] = useState(false);
  const [checkoutUnsaved, setCheckoutUnsaved] = useState(false);
  const [liteSettingsUnsaved, setLiteSettingsUnsaved] = useState(false);
  const [warehousesUnsaved, setWarehousesUnsaved] = useState(false);
  const [paymentMethodUnsaved, setPaymentMethodUnsaved] = useState(false);
  const [stockUnsaved, setStockUnsaved] = useState(false);
  const [mpDtoOrdersUnsaved, setMpDtoOrderUnsaved] = useState(false);
  const [checkedWarehouses, setCheckedWarehouses] = useState([]);
  const [checkedMpDtoOrders, setCheckedMpDtoOrders] = useState([]);
  const [checkedDeliveryPoints, setCheckedDeliveryPoints] = useState([]);

  useLayoutEffect(() => {
    const listener = () => {
      if (window.scrollY > 55) {
        const currentOffset = window.scrollY - 55;
        if (currentOffset !== menuOffset) {
          setMenuOffset(currentOffset);
        }
      } else {
        setMenuOffset(null);
      }

      for (let item in menuData) {
        const element = document.getElementById(`settingsBlock${menuData[item].id}`)?.parentElement;
        if (element && element.offsetTop >= window.scrollY - element.offsetHeight) {
          setCurrentBlock(menuData[item]);
          break;
        }
      }
    };
    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  });

  const menuStyle = {
    transition: 'margin 150ms',
  };
  if (menuOffset !== null) {
    menuStyle.marginTop = menuOffset + 'px';
  }

  const handleMenuSelect = (block) => {
    scrollToBlock(`settingsBlock${block.id}`);
  };

  const formik = useFormik({
    initialValues: {
      deliveryInfo: adminSettings.deliveryInfo?.deliveryInfoList,
      checkout: adminSettings.checkout?.objects[0],
      warehouses: adminSettings.warehouses?.warehouses,
      lite: adminSettings.settings?.objects[0],
      paymentMethod: adminSettings.paymentMethod?.objects,
      stock: stockRevise || [],
      mpDtoOrders: adminSettings.mpDtoOrders?.orders || [],
      mpDtoOrdersTotal: adminSettings.mpDtoOrders?.recordsTotal || 0,
      subtypesFbo: adminSettings.subtypesFbo?.types || [],
    },
    validationSchema,
    enableReinitialize: true,

    onSubmit: async (values) => {
      setLoading(true);
      const refreshActions = [];

      if (deliveryUnsaved) {
        await Promise.all(
          values.deliveryInfoList.map((delivery) => {
            return dispatch(
              fetchUpdateAdminDeliveryInfo({
                ...delivery,
                active: delivery.active,
                adAttachments: delivery.adAttachments,
                aggregatorDeliveryCompany: delivery.aggregatorDeliveryCompany,
                courierTitle: delivery.courierTitle,
                deliveryAggregator: delivery.deliveryAggregator,
                externalKey: delivery.externalKey,
                insurancePercentage: delivery.insurancePercentage,
                isPublicAvailable: delivery.isPublicAvailable,
                marketplace: delivery.marketplace,
                name: delivery.name,
                russianPost: delivery.russianPost,
                type: delivery.type,
                uid: delivery.uid,
                warehouseComments: delivery.warehouseComments,
              }),
            );
          }),
        );
        refreshActions.push(() => dispatch(fetchGetAdminDeliveryInfo()));
        setDeliveryUnsaved(false);
      }

      if (checkoutUnsaved) {
        const uiRequiredFields = [];
        if (values.checkout?.uiRequiredPhone) {
          uiRequiredFields.push('PHONE');
        }
        if (values.checkout?.uiRequiredEmail) {
          uiRequiredFields.push('EMAIL');
        }

        await dispatch(
          fetchUpdateAdminCheckout({
            ...values.checkout,
            allowSNG: values.checkout?.allowSNG,
            deliveryPremiumType: values.checkout?.deliveryPremiumType,
            disableCodSumInTariff: values.checkout?.disableCodSumInTariff,
            freeDeliveryRegion: values.checkout?.freeDeliveryRegion,
            insurancePercent: values.checkout?.insurancePercent,
            onlySufficientOffers: values.checkout?.onlySufficientOffers,
            paymentAccountId: values.checkout?.paymentAccountId,
            paymentProvider: values.checkout?.paymentProvider,
            showStocksPublic: values.checkout?.showStocksPublic,
            realUiRequiredFields: uiRequiredFields,
            uid: values.checkout?.uid,
          }),
        );
      }

      if (liteSettingsUnsaved) {
        await dispatch(
          fetchUpdateAdminSettings({
            ...values.lite,
            businessTariff: values.lite?.businessTariff,
            clientNumber: values.lite?.clientNumber,
            defaultReserveOrders: values.lite?.defaultReserveOrders,
            displayFinance: values.lite?.displayFinance,
            menuCatalog: {
              humanId: values.lite?.menuCatalog.humanId,
              items: values.lite?.menuCatalog.items,
              name: values.lite?.menuCatalog.name,
              uid: values.lite?.menuCatalog.uid,
            },
            needApiProductsReturnDetails: values.lite?.needApiProductsReturnDetails,
            orderEmailFooter: values.lite?.orderEmailHeader,
            orderEmailHeader: values.lite?.orderEmailHeader,
            reportsUseDemoData: values.lite?.reportsUseDemoData,
            useCustomDlvTariffLogin: values.lite?.useCustomDlvTariffLogin,
          }),
        );
        setLiteSettingsUnsaved(false);
      }

      if (warehousesUnsaved && checkedWarehouses.length !== 0) {
        await Promise.all(
          values.warehouses
            .filter((item) => checkedWarehouses.includes(item.uid))
            .map((warehouse) => {
              return dispatch(
                fetchUpdateAdminWarehouse({
                  ...warehouse,
                  accumRegistryEnabled: warehouse.accumRegistryEnabled,
                  active: warehouse.active,
                  children: warehouse.children,
                  default: warehouse.default,
                  defectedWarehouse: warehouse.defectedWarehouse,
                  isAccumRegistryEnabled: warehouse.isAccumRegistryEnabled,
                  isGuaranteedAmount: warehouse.isGuaranteedAmount,
                  name: warehouse.name,
                  operatorType: warehouse.operatorType,
                  packingControl: warehouse.packingControl,
                  uid: warehouse.uid,
                  warehouseOrderType: warehouse.warehouseOrderType,
                  warehouseServicesForTenantList: warehouse.warehouseServicesForTenantList,
                  whOperationType: warehouse.whOperationType,
                }),
              );
            }),
        );
        setWarehousesUnsaved(false);
      }

      if (paymentMethodUnsaved) {
        await Promise.all(
          values.paymentMethod.map((item) => {
            return dispatch(
              fetchUpdateAdminPaymentMethod({
                ...item,
                code: item.code,
                name: item.name,
                paymentMethod: item.paymentMethod,
                uid: item.uid,
              }),
            );
          }),
        );
        setPaymentMethodUnsaved(false);
      }

      if (mpDtoOrdersUnsaved && checkedMpDtoOrders.length !== 0) {
        await Promise.all(
          values.mpDtoOrders
            .filter((item) => checkedMpDtoOrders.includes(item.id))
            .map((mpDtoOrder) => {
              return dispatch(
                fetchUpdateMpDtoOrders({
                  id: mpDtoOrder.id,
                  isProcessed: mpDtoOrder.isProcessed,
                }),
              );
            }),
        );
        setMpDtoOrderUnsaved(false);
      }

      await Promise.all(refreshActions.map((action) => action()));

      toast.info('Настройки успешно сохранены');
      setLoading(false);

      if (stockUnsaved) {
        dispatch(
          fetchUpdateStock({
            ...values.stock,
            lessItems: values.stock.lessItems,
            moreItems: values.stock.moreItems,
          }),
        );
        setStockUnsaved(false);
      }
    },
  });

  const { values, errors, handleSubmit, setFieldValue, isValid } = formik;

  useEffect(() => {
    setCustomHeader(
      deliveryUnsaved ||
        checkoutUnsaved ||
        liteSettingsUnsaved ||
        warehousesUnsaved ||
        paymentMethodUnsaved ||
        stockUnsaved ||
        mpDtoOrdersUnsaved ? (
        <UnsavedHeader handleSubmit={handleSubmit} disabled={!isValid} loading={loading} />
      ) : null,
    );
  }, [
    deliveryUnsaved,
    checkoutUnsaved,
    liteSettingsUnsaved,
    warehousesUnsaved,
    paymentMethodUnsaved,
    stockUnsaved,
    mpDtoOrdersUnsaved,
    loading,
    isValid,
  ]);

  const handleChangeInput = (id, value) => {
    if (/^deliveryInfoList\./.test(id)) {
      setFieldValue(`${id}`, value);
      setDeliveryUnsaved(true);
    }

    if (
      [
        'uiRequiredPhone',
        'uiRequiredEmail',
        'country',
        'currency',
        'allowSNG',
        'commercialAccountDelete',
        'commercialAccountRequested',
        'disableCodSumInTariff',
        'disableInsuranceSumInTariff',
        'disablePRRInTariff',
        'enableExpenseDoc',
        'onlySufficientOffers',
        'policyCheckEnabled',
        'reserveAfterPayment',
        'showConsentToNewsletter',
        'showDeliveryOptions',
        'showStocksPublic',
        'unlockOrderDuringOnlinePayment',
        'useNoCodPaymentName',
        'confidentialPolicyLink',
        'deliveryPremiumType',
        'freeDeliveryRegion',
        'insurancePercent',
        'ownCourierTariff',
        'paymentAccountId',
        'paymentProvider',
      ].indexOf(id) >= 0
    ) {
      setFieldValue(`checkout.${id}`, value);
      setCheckoutUnsaved(true);
    }

    if (['isActivePersonalEmail', 'host', 'username', 'password', 'port'].indexOf(id) >= 0) {
      setFieldValue(`checkout.emailData.${id}`, value);
      setCheckoutUnsaved(true);
    }

    if (
      [
        'businessTariff',
        'clientNumber',
        'defaultReserveOrders',
        'displayFinance',
        'menuCatalog',
        'needApiProductsReturnDetails',
        'reportsUseDemoData',
        'useCustomDlvTariffLogin',
        'defaultVat',
      ].indexOf(id) >= 0
    ) {
      setFieldValue(`lite.${id}`, value);
      setLiteSettingsUnsaved(true);
    }

    if (['humanId', 'name'].indexOf(id) >= 0) {
      setFieldValue(`lite.menuCatalog.${id}`, value);
      setCheckoutUnsaved(true);
    }

    if (
      [
        'accumRegistryEnabled',
        'active',
        'address',
        'children',
        'defectedWarehouse',
        'isAccumRegistryEnabled',
        'isGuaranteedAmount',
        'name',
        'operatorType',
        'packingControl',
        'warehouseOrderType',
        'warehouseServicesForTenantList',
        'whOperationType',
      ].indexOf(id) >= 0
    ) {
      setWarehousesUnsaved(true);
    }

    if (/^paymentMethod\./.test(id)) {
      setFieldValue(`${id}`, value);
      setPaymentMethodUnsaved(true);
    }

    if (/^warehouses\./.test(id)) {
      setFieldValue(`${id}`, value);
      setWarehousesUnsaved(true);
    }

    if (/^stock\./.test(id)) {
      setFieldValue(`${id}`, value);
      setStockUnsaved(true);
    }

    if (/^mpDtoOrders\./.test(id)) {
      setFieldValue(`${id}`, value);
      setMpDtoOrderUnsaved(true);
    }
  };

  return (
    <Wrapper>
      <PageTitle title="Настройки системного администратора" />
      <div className="row">
        <div className="col-9 settings">
          {menuData.map((item) => (
            <ContentWrapper key={item.id} className="card-box">
              <item.component
                settings={adminSettings}
                handleChangeInput={handleChangeInput}
                handleSubmit={handleSubmit}
                values={values}
                errors={errors}
                setCheckedWarehouses={setCheckedWarehouses}
                setCheckedDeliveryPoints={setCheckedDeliveryPoints}
                setCheckedMpDtoOrders={setCheckedMpDtoOrders}
              />
              <div className="block-anchor" id={`settingsBlock${item.id}`} />
            </ContentWrapper>
          ))}
        </div>
        <div className="col-3 menu" style={menuStyle}>
          <PageMenu menuData={menuData} current={currentBlock} onSelect={handleMenuSelect} />
        </div>
      </div>
    </Wrapper>
  );
};

export default AdminPage;
